import moment from 'moment';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { genericErrorMessage } from '@/common/constants';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

function isJSON(str: string): boolean {
  try {
    JSON.parse(str);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return false;
  }
  return true;
}

export function FormatCatchErrorMsg(error: unknown, customMessage?: string): string {
  console.log('🚀 FormatCatchErrorMsg error: ', error);
  let message: unknown = customMessage ? customMessage : genericErrorMessage;
  if (error instanceof Error) message = error.message;
  else {
    if (typeof error === 'object' && error !== null) {
      if ('message' in error) {
        message = error.message;
      } else if ('errorMessage' in error) {
        message = error.errorMessage;
      } else if ('data' in error) {
        if (typeof error.data === 'object' && error.data !== null) {
          if ('message' in error.data) {
            message = error.data.message;
          } else if ('errorMessage' in error.data) {
            message = error.data.errorMessage;
          }
        }
      }
    }
  }

  if (typeof message === 'object' && message !== null) {
    if ('message' in message) {
      message = message.message;
    } else if ('errorMessage' in message) {
      message = message.errorMessage;
    }
  } else if (typeof message === 'string') {
    if (isJSON(message)) {
      const errorMessage = JSON.parse(message as string);
      if (typeof errorMessage === 'object' && errorMessage !== null) {
        if ('message' in errorMessage) {
          message = errorMessage.message;
        } else if ('errorMessage' in errorMessage) {
          message = errorMessage.errorMessage;
        }
      }
    }
  }
  return JSON.stringify(message);
}

export function formatDate(date: unknown, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
  if (!date) return '';

  // Normalize the format to use moment's format tokens (YYYY instead of yyyy)
  const momentFormat = format.replace(/yyyy/g, 'YYYY').replace(/dd/g, 'DD');

  if (typeof date === 'string') {
    // If it's a date-only string (YYYY-MM-DD), parse it as UTC to avoid timezone shifts
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return moment.utc(date).format(momentFormat);
    }
    return moment(date).format(momentFormat);
  }

  if (typeof date === 'number') {
    return moment(date).format(momentFormat);
  }
  if (date instanceof Date) {
    return moment(date).format(momentFormat);
  }
  if (moment.isMoment(date)) {
    return date.format(momentFormat);
  }
  return '';
}
